'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).factory('PromotionRequestRevenue', ['$resource', '$stateParams', 'apiSettings', function ($resource, $stateParams, apiSettings) {
	return $resource(apiSettings.baseUri + 'v1/promotionrequestrevenues/:id', { id: '@id' }, {
		'list': {
			method: 'GET',
			isArray: true,
			params: {
				promotionRequestId: 0
			}
		},
		'listbycustomer': {
			url: apiSettings.baseUri + 'v1/promotionrequestrevenues/list/bycustomer',
			method: 'GET',
			isArray: true,
			params: {
				customerId: 0
			}
		},
		'insert': {
			method: 'POST'
		},
		'update': {
			method: 'PUT'
		},
		'delete': {
			method: 'DELETE'
		}
	});
}]);